// extracted by mini-css-extract-plugin
module.exports = {"main":"_2uw0Lgt1KESgcSlFodETNN","imgCont":"KBozk61dq4lqVY3zB59zx","playCont":"_29bgHH7jdluw7omtHpQB3x","play":"g7DeMWlp3ljfJFnae4Y5w","videoCont":"_20zddxxTTikLSfUsl4LX_x"};